import type { IconNode } from '../types';

/**
 * @name message-circle-dashed-check
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuMSAyLjE4MmExMCAxMCAwIDAxMy44IDAiIC8+CiAgPHBhdGggZD0iTTEzLjkgMjEuODE4YTEwIDEwIDAgMDEtMy44IDAiIC8+CiAgPHBhdGggZD0iTTE3LjYwOSAzLjcyYTEwIDEwIDAgMDEyLjY5IDIuNyIgLz4KICA8cGF0aCBkPSJNMi4xODIgMTMuOWExMCAxMCAwIDAxMC0zLjgiIC8+CiAgPHBhdGggZD0iTTIwLjI4IDE3LjYxYTEwIDEwIDAgMDEtMi43IDIuNjkiIC8+CiAgPHBhdGggZD0iTTIxLjgxOCAxMC4xYTEwIDEwIDAgMDEwIDMuOCIgLz4KICA8cGF0aCBkPSJNMy43MjEgNi4zOTFhMTAgMTAgMCAwMTIuNy0yLjY5IiAvPgogIDxwYXRoIGQ9Im02LjE2MyAyMS4xMTctMi45MDYuODVhMSAxIDAgMDEtMS4yMzYtMS4xNjlsLjk2NS0yLjk4IiAvPgogIDxwYXRoIGQ9Im0xNiA5LTUuNSA1LjVMOCAxMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/message-circle-dashed-check
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MessageCircleDashedCheck: IconNode = [
  ['path', { d: 'M10.1 2.182a10 10 0 013.8 0' }],
  ['path', { d: 'M13.9 21.818a10 10 0 01-3.8 0' }],
  ['path', { d: 'M17.609 3.72a10 10 0 012.69 2.7' }],
  ['path', { d: 'M2.182 13.9a10 10 0 010-3.8' }],
  ['path', { d: 'M20.28 17.61a10 10 0 01-2.7 2.69' }],
  ['path', { d: 'M21.818 10.1a10 10 0 010 3.8' }],
  ['path', { d: 'M3.721 6.391a10 10 0 012.7-2.69' }],
  ['path', { d: 'm6.163 21.117-2.906.85a1 1 0 01-1.236-1.169l.965-2.98' }],
  ['path', { d: 'm16 9-5.5 5.5L8 12' }],
];

export default MessageCircleDashedCheck;
